import { ref, watch } from "vue";
import { CircleCheckFilled } from "@element-plus/icons-vue";
import store from "@/store";
export default {
  name: "translateX",
  components: {
    CircleCheckFilled
  },
  setup() {
    let X = ref("translateX(165px)");
    watch(() => store.state.interval2, v => {
      if (store.state.deviceState.mode == 2) {
        return;
      }
      if (v) {
        X.value = "translateX(-165px)";
      } else {
        X.value = "translateX(0)";
        setTimeout(() => {
          X.value = "translateX(-165px)";
        }, 2000);
      }
    });
    return {
      X
    };
  }
};